var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntroFourthIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 58,
    viewBox: "0 0 61 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7606 37.7861H37.3124C38.8165 37.7861 40.0359 36.5669 40.0359 35.0629V23.512C40.0359 22.008 38.8165 20.7888 37.3124 20.7888H25.7606C24.2565 20.7888 23.0372 22.008 23.0372 23.512V35.0629C23.0372 36.5669 24.2565 37.7861 25.7606 37.7861Z",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1448 33.4066L29.9136 25.1689L32.6824 33.4066",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9277 25.1689V33.4066",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7122 31.7051H32.115",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.084 31.5226C55.3248 31.5226 56.3308 30.5167 56.3308 29.276C56.3308 28.0352 55.3248 27.0293 54.084 27.0293C52.8431 27.0293 51.8372 28.0352 51.8372 29.276C51.8372 30.5167 52.8431 31.5226 54.084 31.5226Z",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1648 49.4054C46.4057 49.4054 47.4116 48.3995 47.4116 47.1587C47.4116 45.918 46.4057 44.9121 45.1648 44.9121C43.9239 44.9121 42.918 45.918 42.918 47.1587C42.918 48.3995 43.9239 49.4054 45.1648 49.4054Z",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2468 31.5226C4.48769 31.5226 5.49367 30.5167 5.49367 29.276C5.49367 28.0352 4.48769 27.0293 3.2468 27.0293C2.00592 27.0293 1 28.0352 1 29.276C1 30.5167 2.00592 31.5226 3.2468 31.5226Z",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4114 43.9132C16.6523 43.9132 17.6582 42.9074 17.6582 41.6666C17.6582 40.4258 16.6523 39.4199 15.4114 39.4199C14.1705 39.4199 13.1646 40.4258 13.1646 41.6666C13.1646 42.9074 14.1705 43.9132 15.4114 43.9132Z",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5478 10.8946C32.7887 10.8946 33.7946 9.88879 33.7946 8.64801C33.7946 7.40722 32.7887 6.40137 31.5478 6.40137C30.3069 6.40137 29.301 7.40722 29.301 8.64801C29.301 9.88879 30.3069 10.8946 31.5478 10.8946Z",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.358 13.8673C54.5988 13.8673 55.6048 12.8614 55.6048 11.6207C55.6048 10.3799 54.5988 9.37402 53.358 9.37402C52.1171 9.37402 51.1111 10.3799 51.1111 11.6207C51.1111 12.8614 52.1171 13.8673 53.358 13.8673Z",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13062 19.132C9.21575 8.53421 19.4966 1 31.5478 1C39.6046 1 46.8897 4.38132 52.0416 9.78234",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.626 16.2041C58.6686 20.1074 59.826 24.5779 59.826 29.2982C59.826 44.9112 47.1621 57.5741 31.5478 57.5741C16.7732 57.5741 4.65399 46.2501 3.38306 31.8171",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8784 37.3096C44.643 38.8527 49.6813 42.166 53.358 46.6365",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1816 40.2597C19.3604 38.9662 21.7207 37.9677 24.2172 37.3096",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44263 46.9542C10.6455 45.4564 12.0072 44.0721 13.4824 42.8467",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1944 21.2655C18.4298 19.7223 13.3915 16.4091 9.71484 11.9385",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0416 13.4365C48.5012 17.1582 43.9848 19.9041 38.8784 21.2657",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1237 51.9694C39.1733 55.4869 35.5194 57.552 31.5477 57.552C25.7151 57.552 20.5179 53.036 17.2952 46.0918",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3674 36.3336C14.0043 34.0869 13.8228 31.7268 13.8228 29.2759C13.8228 13.6629 21.7661 1 31.5477 1C41.3293 1 49.2726 13.6629 49.2726 29.2759C49.2726 35.1308 48.1606 40.5772 46.2542 45.0932",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0359 29.2764H51.8147",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51636 29.2764H23.0371",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5479 37.7861V57.5747",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5479 10.8945V20.7888",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroFourthIcon02);
export default __webpack_public_path__ + "static/media/intro_fourth_icon_02.4d668e8c814735f35f7db3d154cc4d67.svg";
export { ForwardRef as ReactComponent };